import { endpoints } from '../config'
import { getApiClient } from './api-client'

export async function getContent() {
  return getApiClient({ endpoint: `${endpoints.content}` })
}
